module.exports = __webpack_public_path__ + "img/logo-docplanner-turquoise-rgb.390b6555.png";